import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-user-info-modal',
  templateUrl: './user-info-modal.component.html',
})
export class UserInfoModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UserInfoModalComponent>
  ) { }

  verify() {
    this.dialogRef.close(true); // return something if needed
  }
}
